module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_9016.9bef0935.png";